module.exports = __webpack_public_path__ + "img/SKMJ_lift2.630408f2.jpg";